import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useHouseholdCreateMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: Api.IHousehold) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ createHouseholdRequest }: { createHouseholdRequest: Api.CreateHouseholdRequest }) => {
			return userSession.webServiceHelper.callAsync<Api.IHousehold>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `household`,
				}),
				'POST',
				createHouseholdRequest
			);
		},
		onError,
		onSuccess,
	});
}
